// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".what-we-do-scroll-list{display:flex;flex-direction:column;align-items:center;padding:var(--section-padding-top) 0 0}@media(min-width:992px){.what-we-do-scroll-list{margin-right:32px;padding:calc(25vh - var(--what-we-do-navigation-width)*0.25) 16px;flex:0 0 40%}}@media(min-width:1200px){.what-we-do-scroll-list{flex:0 0 33.33%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
